// Routes du super administrateur de la plateforme (D-080), raccordées par une ligne dans Application.tsx.
import { Navigate, type RouteObject } from 'react-router';
import { PageModulesPlateforme } from './PageModulesPlateforme';

export const routesPlateforme: RouteObject[] = [
  { path: '/plateforme', element: <Navigate to="/plateforme/modules" replace /> },
  { path: '/plateforme/modules', element: <PageModulesPlateforme /> },
];
